import { render, staticRenderFns } from "./PelletsHeroSection.vue?vue&type=template&id=a916cd46&scoped=true"
import script from "./PelletsHeroSection.vue?vue&type=script&lang=ts"
export * from "./PelletsHeroSection.vue?vue&type=script&lang=ts"
import style0 from "./PelletsHeroSection.vue?vue&type=style&index=0&id=a916cd46&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a916cd46",
  null
  
)

export default component.exports